// extracted by mini-css-extract-plugin
export default {"dashTimeInfo":"CurrentTime_dashTimeInfo__inlvc"};